export default {
    'testimony': require( './testimony.js' ),
    'challenges': require( './challenges.js' ),
    'header': require( './header.js' ),
    'video': require( './video.js' ),
    'article-list': require( './article-list.js' ),
    'push-article':require('./push-article.js'),
    'reveal': require('./split-type.js'),
    'site-loader':require('./site-loader.js'),
    'google-map':require('./google-map.js'),
    'google-reviews':require('./google-reviews.js'),
    'realisations':require('./realisations.js'),
    'contact-form':require('./contact-form.js'),
}
